import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgxPowerBiModule } from 'ngx-powerbi';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SharedUIModule } from '../shared/shared-ui.module';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MatExpansionModule } from '@angular/material/expansion';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ImpactAssessmentRoutes } from './impact-assessment.routes';
import { GDPRService } from './../../core/services/rulebook/gdpr.service';
import { ImpactAssessmentComponent } from './impact-assessment.component';
import { CommonService } from './../../core/services/common/common.service';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { ImpactService } from 'src/app/core/services/impact/impact.service';
import { ImpactOutcomeComponent } from './impact-outcome/impact-outcome.component';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { RegulationService } from './../../core/services/regulation/regulation.service';
import { DistributedUIModule } from '../distributed-ui-components/distributed-ui.module';
import { LinkedAssessmentComponent } from './linked-assessment/linked-assessment.component';
import { BulkUpdateDialogComponent } from './bulk-update-dialog/bulk-update-dialog.component';
import { ImpactRatingDialogComponent } from './impact-rating-dialog/impact-rating-dialog.component';
import { ImpactAssessmentDialogComponent } from './impact-assessment-dialog/impact-assessment-dialog.component';
import { ImpactAssessmentDetailsComponent } from './impact-assessment-details/impact-assessment-details.component';
import { ImpactAssessmentSummaryComponent } from './impact-assessment-summary/impact-assessment-summary.component';
import { ImpactAssessmentDashboardComponent } from './impact-assessment-dashboard/impact-assessment-dashboard.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BulkUpdateT4DialogComponent } from './bulk-update-t4-dialog/bulk-update-t4-dialog.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { BulkUpdateDialogT5Component } from './bulk-update-dialog-t5/bulk-update-dialog-t5.component';
import { ImpactAssessmentDashboard2Component } from './impact-assessment-dashboard2/impact-assessment-dashboard2.component';
//import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';

@NgModule({
  declarations: [
    ImpactAssessmentComponent,
    ImpactAssessmentDetailsComponent,
    ImpactAssessmentSummaryComponent,
    ImpactAssessmentDialogComponent,
    ImpactAssessmentDashboardComponent,
    ImpactOutcomeComponent,
    LinkedAssessmentComponent,
    BulkUpdateDialogComponent,
    ImpactRatingDialogComponent,
    BulkUpdateT4DialogComponent,
    BulkUpdateDialogT5Component,
    ImpactAssessmentDashboard2Component,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AlertModule.forRoot(),
    RouterModule.forChild(ImpactAssessmentRoutes),
    MatDialogModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatInputModule,
    MatDatepickerModule,
    DistributedUIModule,
    MatChipsModule,
    BsDropdownModule,
    SharedUIModule,
    ScrollingModule,
    NgxPowerBiModule,
    AngularEditorModule,
    MatExpansionModule,
    NgSelectModule,
    MatSlideToggleModule,
    CKEditorModule
  ],
  providers: [
    GDPRService,
    ImpactService,
    AnalyticsService,
    SessionService,
    CommonService,
    RegulationService,
  ],
  entryComponents: [
    ImpactAssessmentDialogComponent,
    LinkedAssessmentComponent,
    BulkUpdateDialogComponent,
    ImpactAssessmentDetailsComponent,
    ImpactOutcomeComponent,
    ImpactRatingDialogComponent,
    BulkUpdateT4DialogComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class ImpactAssessmentModule {}
